import { combineReducers } from "redux";
import list from "./promotionListReducer";

export default combineReducers({
  list
});
